<div class="back-button-wrapper" (click)="back()">
    <img src="assets/icons/gl_arrow_left.svg" />
    <span>
      {{ 'general.backLowercase' | translate }}
    </span>
  </div>